// extracted by mini-css-extract-plugin
export default {"text":"styles-text-e06253","button":"styles-button-b03b56"};